import { ToastManager } from '../../../ToastManager';

import { ResourceUtils } from '../../../store/ResourceUtils';

import { useI18n } from '../../../hooks/useI18nFormatters';
import { useApi } from '../../../store/SelectedHomeyStore.hooks';

import { glyph } from '../../../theme/glyph';

import { ContextMenuContent } from '../../../components/common/context-menu/ContextMenuContent';
import { DeveloperMenu } from '../../../components/common/context-menu/DeveloperMenu';

import { FlowCardMissingContextMenuContent } from './FlowCardMissingContextMenuContent';

export function FlowCardConditionContextMenuContent(props) {
  const { i18n } = useI18n();

  const { api } = useApi();

  async function onAction(key) {
    switch (key) {
      case 'replace':
        props.onReplaceRequest();
        break;
      case 'duplicate':
        props.onDuplicateRequest();
        break;
      case 'run': {
        async function run() {
          try {
            const response = await api.flow.runFlowCardCondition({
              id: props.data.id,
              args: props.data.args,
              droptoken: props.data.droptoken,
            });

            if (props.data.inverted) {
              response.result = !response.result;
            }

            ToastManager.add({
              icon: glyph.core.checkmark,
              message: i18n.messageFormatter('flow.cardConditionResult', {
                condition: i18n.messageFormatter(`common.${String(response.result ?? 'unknown')}`),
              }),
            });
          } catch (error) {
            ToastManager.handleError(error);
          }
        }

        run();
        break;
      }

      case 'invert':
        props.onInvertRequest();
        break;
      case 'delete':
        props.onDeleteRequest();
        break;
      default:
        break;
    }
  }

  if (props.card == null) {
    return <FlowCardMissingContextMenuContent {...props} />;
  }

  return (
    <ContextMenuContent.List>
      <ContextMenuContent.ListItem
        label={i18n.messageFormatter('common.duplicate')}
        icon={glyph.core.squareFilledOnSquare}
        onPress={() => {
          onAction('duplicate');
        }}
      />

      <ContextMenuContent.ListItem
        label={i18n.messageFormatter('common.replace')}
        icon={glyph.core.arrowDoubleSquare}
        onPress={() => {
          onAction('replace');
        }}
      />

      <ContextMenuContent.ListItem
        label={i18n.messageFormatter('common.test')}
        icon={glyph.core.play}
        onPress={() => {
          onAction('run');
        }}
      />

      <ContextMenuContent.Divider />

      <ContextMenuContent.ListItem
        label={i18n.messageFormatter('flow.invert')}
        onPress={() => {
          onAction('invert');
        }}
      />

      <DeveloperMenu
        onIdRequest={() => props.card?.id}
        onUriRequest={() => ResourceUtils.getOwnerUri(props.card ?? props.data)}
        onResourceRequest={() => {
          return {
            card: props.card,
            data: props.data,
          };
        }}
      />

      <ContextMenuContent.Divider />
      <ContextMenuContent.ListItem
        label={i18n.messageFormatter('common.delete')}
        variant="danger"
        icon={glyph.core.trashFill}
        onPress={() => {
          onAction('delete');
        }}
      />
    </ContextMenuContent.List>
  );
}
